import React, { Component } from 'react';
import { connect } from 'react-redux';

import store from '../../store';
import { updateSeatChart, updateSeatChartDet } from '../../actions/search-actions'
import { getDur, get24HrTime, getPointTime, fetchGet } from '../../common/common';

import Seatchart from '../seatchart/seatchart';

const repetitions = 10; //repetitions
const delay = 10; //milliseconds
let delayCounter = 0;
let tempScroll, currScrollPos, prevScrollTop;

class Listing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            showDet: {},
            seoChartactive: false,
        }
    }

    componentDidMount() {
        let stNo = window.location.search;
        stNo =
        stNo.split("&rsid=").length > 1
        ? stNo.split("&rsid=")[1].split("&")[0]
        : false;
        const stParams = stNo ? true : false;
        stNo && this.setState({ seoChartactive: true });
        store.dispatch(updateSeatChart(stNo, stParams));
        if (stNo) {
            const url = window.url + "/api/resource/getRouteInfo?routeID=" + stNo;
            fetchGet(url)
            .then((data) => {
                store.dispatch(updateSeatChartDet(stNo, data));
            })
            .catch((err) => console.log(err));
        }
        window.addEventListener('click', (e) => {
            if (this.refs.tooltip) {
                if(!(e.target.className === 'list-pick' || e.target.parentNode.className  === 'list-pick' || e.target.parentNode.parentNode.className === 'list-pick')) {
                    this.setState({ showDet: {} })
                }
            }
        })
    }

    showAmenities = (val) => {
        val = val && val.length > 0 ? val.split(',') : [];
        if (val.length > 0) {
            return(
                val.map((amen, index) => {
                    // if (index < 5) {
                        return <img key={index} src={'/img/' + amen + '.svg'} alt={amen} title={amen} />;
                    // }
                    // return '';
                })
            )
        }
    }
    showDiscount = (val) => {
        if (val.DiscountAmt > 0) {
            return <div>{this.props.search.currency}{ val.Fare - val.DiscountAmt }</div>;
        }
        if (val.DiscountPer > 0) {
            return <div>{this.props.search.currency}{ (val.Fare - Math.floor(val.Fare * val.DiscountPer / 100)) }</div>;
        }
        return <div>{this.props.search.currency}{val.Fare}</div>;
    }

    showSeatchart = (val) => {
        if (this.props.search.stChrtStatus[val.RouteScheduleId]) {
            return (
              <Seatchart
                seat={val}
                DefaultCurrencyID={val.DefaultCurrencyID}
                close={this.closeSeatchart}
                seoChartactive={this.state.seoChartactive}
              />
            );
          }
    }

    showPolicy = (rsid) => {
        if (this.state.showDet[rsid] === 1) {
            const loop = this.props.search.stChrtOthrDtls[rsid] ? this.props.search.stChrtOthrDtls[rsid].cnclDetails : false;
            if (loop) {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-' + Math.floor(((Object.keys(loop).length * 29) + 55) / 2) + 'px'
                        }}
                    >
                        <div>
                            <div>Time before Departure</div>
                            <div>Charges</div>
                        </div>
                        {
                            Object.keys(loop).map(el => {
                                return (
                                    <div key = {el}>
                                        <div>Within {loop[el]}</div>
                                        <div>{el}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            } else {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-20px'
                        }}
                    >
                        Loading...
                    </div>
                )
            }
        }
    }

    showPick = (rsid) => {
        if (this.state.showDet[rsid] === 2) {
            const loop = this.props.search.stChrtOthrDtls[rsid] ? this.props.search.stChrtOthrDtls[rsid].pickups : false;
            if (loop) {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-' + Math.floor(((Object.keys(loop).length * 29) + 55) / 2) + 'px'
                        }}
                    >
                        <div>
                            <div>Pickup Point</div>
                            <div>Time</div>
                        </div>
                        {
                            loop.map((el, index) => {
                                return (
                                    <div key = {index}>
                                        <div>{ el.PickupName }</div>
                                        <div>{ getPointTime(el.PickupTime) }</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            } else {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-20px'
                        }}
                    >
                        Loading...
                    </div>
                )
            }
        }
    }

    showDrop = (rsid) => {
        if (this.state.showDet[rsid] === 3) {
            const loop = this.props.search.stChrtOthrDtls[rsid] ? this.props.search.stChrtOthrDtls[rsid].dropPoints : false;
            if (loop) {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-' + Math.floor(((Object.keys(loop).length * 29) + 55) / 2) + 'px'
                        }}
                    >
                        <div>
                            <div>Dropoff Point</div>
                            <div>Time</div>
                        </div>
                        {
                            loop.map((el, index) => {
                                return (
                                    <div key = {index}>
                                        <div>{ el.DropoffName }</div>
                                        <div>{ getPointTime(el.DropoffTime) }</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            } else {
                return (
                    <div
                        ref = 'tooltip'
                        className = 'list-pick'
                        style = {{
                            top: '-20px'
                        }}
                    >
                        Loading...
                    </div>
                )
            }
        }
    }

    openSeatchart = (e, rsid) => {
        const card = e.target.parentNode.parentNode;
        currScrollPos = card.getBoundingClientRect().top;
        prevScrollTop = window.scrollY;
        this.animateSeat();
        
        if(!this.props.search.stChrtOthrDtls[rsid]) {
            const url = window.url + '/api/resource/getRouteInfo?routeID=' + rsid;
            fetchGet(url)
            .then(data => {
                store.dispatch(updateSeatChartDet(rsid, data));
            })
            .catch((err) => console.log(err));
        }
        store.dispatch(updateSeatChart(rsid, true));
    }

    animateSeat = () => {
        delayCounter = 0;
        tempScroll = currScrollPos / repetitions;
        this.moveSeat();
    }

    moveSeat = () => {
        const scrollY = window.scrollY + tempScroll;
        window.scrollTo(0, scrollY);

        if (delayCounter !== repetitions) {
            delayCounter++;
            setTimeout(this.moveSeat, delay);
        } else {
            window.scrollTo(0, prevScrollTop + currScrollPos);
        }
    }

    closeSeatchart = (rsid) => {
        store.dispatch(updateSeatChart(rsid, false));
    }

    openOtherDet = (e, rsid, param) => {
        // store.dispatch(updateSeatChartDet(rsid, []));
        e.stopPropagation();
        let showDet = {};
        showDet[rsid] = param;
        this.setState({ showDet });
        if (!this.props.search.stChrtOthrDtls[rsid]) {
            // const that = this;
            const url = window.url + '/api/resource/getRouteInfo?routeID=' + rsid;
            // fetch(url).then(function(response){
            //     return response.json();
            // }).then(function(data) {
            //     store.dispatch(updateSeatChartDet(rsid, data));
            //     that.setState({ showDet });
            // }).catch(function(error) {
            //     console.log('There has been a problem with your fetch operation: ' + error.message);
            // });
            fetchGet(url)
            .then(data => {
                store.dispatch(updateSeatChartDet(rsid, data));
            })
            .catch((err) => console.log(err));
        } else {
            if (this.state.showDet[rsid] === param) {
                this.setState({ showDet: {} })
            } else this.setState({ showDet });
        }
    }

    showDiscountTag = (val) => {
        if (val.DiscountPer > 0) {
            return <div style = { this.discountTag } className="discountTag">{ val.DiscountPer }% Off</div>;
        }
        if (val.DiscountAmt > 0) {
            return <div style = { this.discountTag } className="discountTag">&#8377;{ val.DiscountAmt } Off</div>;
        }
    }

    render() {
        const loop = this.props.search.buses;
        if (loop.length > 0) {
            return loop.map(el => {
                if (el.AvailableSeats > 0) {
                    const disFare = el.DiscountPer > 0 || el.DiscountAmt > 0 ? true : false;
                    return (
                        <div key = { el.RouteScheduleId } 
                            className={
                            this.state.seoChartactive &&
                            this.props.search.stChrtStatus[el.RouteScheduleId]
                              ? "srch-card active"
                              : "srch-card"
                          }>
                            <div className = 'srch-names'>
                                <div>{ el.CompanyName.toLowerCase()}</div>
                                <div style={{
                                    color : el.HasAC ? '#e31f24' : '#006600',
                                    fontWeight: 500,
                                    fontSize: '13px'
                                }}>
                                    { el.HasAC ? 'AC ' : '' }
                                    { el.HasNAC ? 'Non AC ' : '' }
                                    { el.HasSeater ? 'Seater ' : '' }
                                    { el.HasSleeper ? 'Sleeper ' : '' }
                                    { el.BusType.toLowerCase() } { el.Suffix ? ' - ' + el.Suffix.toLowerCase() : '' }
                                </div>
                                <div>
                                    <span
                                        style = {{
                                            position: 'relative',
                                            color: window.color.searchBoxBgColor,
                                            cursor: 'pointer'
                                        }}
                                        onClick = { (event) => this.openOtherDet(event, el.RouteScheduleId, 1) }
                                    >
                                        Policy
                                        { this.showPolicy(el.RouteScheduleId) }
                                    </span>
                                    &nbsp;&nbsp;
                                    { this.showAmenities(el.AmenitiesType) }
                                </div>
                            </div>
                            <div className = 'srch-times'>
                                <div>
                                    <div>{ get24HrTime(el.DepartureTime) }</div>
                                    <div
                                        style = {{
                                            position: 'relative',
                                            color: window.color.searchBoxBgColor,
                                            cursor: 'pointer'
                                        }}
                                        onClick = { (event) => this.openOtherDet(event, el.RouteScheduleId, 2) }
                                    >
                                        Pickup
                                        { this.showPick(el.RouteScheduleId) }
                                    </div>
                                </div>
                                <div className = 'dur'>
                                    <div>{ getDur(el.DepartureTime, el.ArrivalTime) }</div>
                                    <div></div>
                                </div>
                                <div>
                                    <div>{ get24HrTime(el.ArrivalTime) }</div>
                                    <div
                                        style = {{
                                            position: 'relative',
                                            color: window.color.searchBoxBgColor,
                                            cursor: 'pointer'
                                        }}
                                        onClick = { (event) => this.openOtherDet(event, el.RouteScheduleId, 3) }
                                    >
                                        Dropoff
                                        { this.showDrop(el.RouteScheduleId) }
                                    </div>
                                </div>
                            </div>
                            <div className = 'srch-seats'>
                                <div>{ el.AvailableSeats }</div>
                                <div>Seats Left</div>
                            </div>
                            <div className = 'srch-fares'>
                                { this.showDiscount(el) }
                                <div>{disFare ? this.props.search.currency + el.Fare : ''}</div>
                                { disFare ? this.showDiscountTag(el) : ''}
                                <div
                                    onClick = { (event) => this.openSeatchart(event, el.RouteScheduleId) }
                                    style = {{
                                        background: !this.props.search.stChrtStatus[el.RouteScheduleId] ? window.color.buttonColor : '#fff',
                                        borderColor: !this.props.search.stChrtStatus[el.RouteScheduleId] ? window.color.buttonColor : '#ddd',
                                        border: '1px solid',
                                        color: !this.props.search.stChrtStatus[el.RouteScheduleId] ? '#fff' : '#ddd'
                                    }}
                                >SELECT</div>
                            </div>
                            { this.showSeatchart(el) }
                        </div>
                    )
                } else {
                    return '';
                }
            })
        } else if (loop.length === 0) {
            if (this.props.search.data.length > 0) {
                return <div style = {{ textAlign: 'center', padding: '5px', color: '#ff1f70'}}>Sorry! All seats are booked for {this.props.search.searchParams.fromCity.split('|')[1]} to {this.props.search.searchParams.toCity.split('|')[1]} - Please Modify your Search in the search box above.</div>
            } else {
                return (
                    <div className='loading'>
                    Loading...
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                )
            }
        } else {
            return <div style = {{ textAlign: 'center', padding: '5px', color: '#ff1f70'}}>Sorry! There were no results found for {this.props.search.searchParams.fromCity.split('|')[1]} to {this.props.search.searchParams.toCity.split('|')[1]} - Please Modify your Search in the search box above.</div>
        }
    }
}


const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Listing);